import React from "react";

// Component-specific props.
type ComponentProps = {
  color: string;
  size: number | string;
  margin: number | string;
  active?: boolean;
};

function Node(props: ComponentProps) {
  return (
    <div
      style={{
        width: props.size + "px",
        height: props.size + "px",
        aspectRatio: 1,
        marginRight: props.margin + "px",
        borderRadius: "50%",
        backgroundColor: !props.active ? undefined : props.color,
        border: !props.active ? "solid 2px white" : undefined,
        boxShadow: "-1px 1px #33333366",
      }}
    />
  );
}

Node.defaultProps = {
  color: "#333",
  size: 20,
  margin: 2,
  active: true,
};

export default Node;
